import { parseUnits } from 'ethers/lib/utils';
// import { useWeb3React } from '@web3-react/core';
// import { BigNumber } from 'ethers';
// import useSWR from 'swr';
// import abis from '../../config/contracts/abis';
// import { fetcher } from '../../web3/utils';

const useUserBalance = (tokenAddress: string | undefined) => {
    return parseUnits('100', 6);
    // const { account, library } = useWeb3React();

    // const { data: balance } = useSWR<BigNumber>(
    //     library && account && tokenAddress ? [tokenAddress, 'balanceOf', account] : null,
    //     {
    //         fetcher: fetcher(library, abis.erc20),
    //         fallbackData: parseEther('0'),
    //         refreshInterval: 5000,
    //         dedupingInterval: 5000,
    //     }
    // );

    // return  balance;
};

export default useUserBalance;
